import * as Clipboard from 'clipboard/dist/clipboard.js';

export { Clipboard };
